import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/waze': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.2 201.7c14.5 85.9-30.9 167.9-113.2 208.1 13 34.1-12.4 70.2-48.3 70.2-27.1 0-50.2-22-51.6-49-6.4 0.2-64.2 0-76.3-0.6-1.1 27.4-24.2 49.6-51.6 49.6-0.6 0-1.5 0-2.1 0-33.9-1.4-58-34.8-47-67.9-37.2-13.1-72.5-34.9-99.6-70.8-13-17.3-0.5-41.8 20.8-41.8 46.3 0 32.2-54.2 43.2-110.3 18.4-93.9 116.8-157.1 211.7-157.1 102.5 0 197.2 70.7 214.1 169.7zM373.5 388.3c42-19.2 81.3-56.7 96.3-102.1 40.5-123.1-64.1-228-181.7-228-83.5 0-170.3 55.4-186.1 136-9.5 48.9 5 131.4-68.8 131.4 24.9 33.1 58.3 52.6 93.7 64 24.7-21.8 63.9-15.5 79.8 14.3 14.2 1 79.2 1.2 87.9 0.8 8-15.5 28.6-28.1 46-28.1 10.2 0 24.9 5.2 32.8 11.7zM205.1 187.1c0-34.7 50.8-34.8 50.8 0s-50.8 34.7-50.8 0zM321.7 187.1c0-34.7 50.9-34.8 50.9 0s-50.9 34.8-50.9 0zM199.1 257.8c-3.4-16.9 22.2-22.2 25.6-5.2l0.1 0.3c4.1 21.4 29.9 44 64.1 43.1 35.7-0.9 59.3-22.2 64.1-42.8 4.5-16.1 28.6-10.4 25.5 6-5.2 22.2-31.2 62-91.5 62.9-42.5 0-80.9-27.8-87.9-64.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/waze.js
// module id = 1084
// module chunks = 0